export default "__VITE_ASSET__CLI7XJr5__"